import React, { useState } from 'react'
import { useMutation } from '@apollo/client'
import Button from '../../components/atoms/Buttons'
import { SEND_BOOKING_INVOICE } from '../../apollo/mutations/booking'
import './style.css'

const SendInvoiceModal = ({ booking, onClose, onDone }) => {
  const [errorText, setErrorText] = useState('')
  const [hostedUrl, setHostedUrl] = useState('')
  const [send, { loading }] = useMutation(SEND_BOOKING_INVOICE, {
    refetchQueries: ['listBookingsByDate'],
  })

  const submit = async () => {
    setErrorText('')
    try {
      const { data } = await send({ variables: { id: booking.id } })
      const url = data?.sendBookingInvoice?.invoiceHostedUrl
      if (url) setHostedUrl(url)
      else onDone?.()
    } catch (err) {
      setErrorText(err?.message || 'Could not send invoice.')
    }
  }

  const amount = booking.balanceDue ? `$${(booking.balanceDue / 100).toFixed(2)}` : '$0.00'

  return (
    <div>
      <div className="booking-modal-backdrop" onClick={onClose} />
      <div className="booking-modal-container" style={{ maxWidth: 460, width: '92%' }}>
        <h2 className="add-events !text-[24px] !mt-0 mb-2">Send Invoice</h2>
        {!hostedUrl ? (
          <>
            <p className="text-[14px] font-montserrat text-[#343434] mb-4">
              Email a Stripe invoice for <strong>{amount}</strong> to{' '}
              <strong>{booking.customerEmail}</strong>? They'll get a secure pay-online link, due in 7 days.
            </p>
            {errorText && <div className="text-[13px] text-[color:var(--color-primary-danger)] mb-3">{errorText}</div>}
            <div className="flex gap-x-3 justify-center">
              <Button type="button" loading={loading} onClick={submit} primary>
                Send Invoice
              </Button>
              <Button type="button" onClick={onClose} primaryOutline>
                Cancel
              </Button>
            </div>
          </>
        ) : (
          <>
            <p className="text-[14px] text-green-700 font-semibold mb-2">Invoice sent ✓</p>
            <p className="text-[12px] text-[color:var(--color-gray-text)] font-montserrat mb-2">Hosted invoice link:</p>
            <a
              href={hostedUrl}
              target="_blank"
              rel="noreferrer"
              className="text-[color:var(--color-secondary)] underline break-all text-[12px]"
            >
              {hostedUrl}
            </a>
            <div className="flex justify-center mt-5">
              <Button type="button" onClick={onDone} primary>
                Done
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default SendInvoiceModal
